import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import type { StructuredContentDocument } from '../hydration/types';
export const SIZE_PROPS: Record<'horizontal' | 'vertical', CSSProperties> = {
  horizontal: {
    width: '100%',
    height: 200
  },
  vertical: {
    width: 275,
    height: 455
  }
};
export type MegaphoneFmProps = StructuredContentDocument<{
  url: string;
  title?: string;
  orientation?: keyof typeof SIZE_PROPS;
}>;
const extractMediaIdFromUrl = (url: string): string | null => {
  const regex = /\/([A-Z0-9]+)\.mp3/;
  const match = url.match(regex);
  return match ? match[1] : null;
};
export const MegaphoneFm = t0 => {
  const $ = _c(11);
  const {
    props: t1
  } = t0;
  const {
    url,
    title: t2,
    orientation: t3
  } = t1;
  const title = t2 === undefined ? "Megaphone Content" : t2;
  const orientation = t3 === undefined ? "horizontal" : t3;
  if (!url) {
    console.error("Megaphone component is missing a URL");
    return null;
  }
  let t4;
  if ($[0] !== url) {
    t4 = extractMediaIdFromUrl(url);
    $[0] = url;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const mediaId = t4;
  if (!mediaId) {
    console.error("Megaphone media ID is missing or invalid");
    return null;
  }
  let t5;
  if ($[2] !== mediaId || $[3] !== orientation) {
    const finalUrlObj = new URL(`https://player.megaphone.fm/${mediaId}`);
    if (orientation === "vertical") {
      finalUrlObj.searchParams.set("tile", "true");
    }
    t5 = finalUrlObj.toString();
    $[2] = mediaId;
    $[3] = orientation;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const finalUrl = t5;
  const t6 = SIZE_PROPS[orientation];
  let t7;
  if ($[5] !== t6) {
    t7 = {
      border: 0,
      overflow: "hidden",
      display: "block",
      ...t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== finalUrl || $[8] !== t7 || $[9] !== title) {
    t8 = <div><iframe title={title} src={finalUrl} loading="lazy" style={t7} /></div>;
    $[7] = finalUrl;
    $[8] = t7;
    $[9] = title;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};